import { Redirect } from 'expo-router';

export default function CashAccountFAQScreen() {
    return <Redirect href="/settings/faq" />;
}
